export default __webpack_public_path__ + "src/_images/Override_Icon.svg";